import React, { useState } from "react";
import { NavLink, Redirect, Route, Switch } from "react-router-dom";
import { ConfigProvider, Layout } from "antd";
import { IntlProvider } from "react-intl";
import elGR from "antd/es/locale/el_GR";
import enGB from "antd/es/locale/en_GB";
import translations from "../../i18n/locales";
import CarpetPreviewProvider from "./context";
import CheckIn from "./CheckIn";
import CheckOut from "./CheckOut";
import Entries from "./Entries";
import Report from "./Report";
import ClientCarpets from "./ClientCarpets";

const { Header, Content } = Layout;

const links = [
  ["/preview/check-in", "checkIn"],
  ["/preview/check-out", "checkOut"],
  ["/preview/entries", "entries"],
  ["/preview/client", "carpets"],
];

export default function CarpetPreview() {
  const [locale, setLocale] = useState("el");

  return (
    <IntlProvider locale={locale} messages={translations[locale]}>
      <ConfigProvider locale={locale === "el" ? elGR : enGB}>
        <CarpetPreviewProvider>
          <Layout style={{ minHeight: "100vh", background: "#fff" }}>
            <Header className="preview-chrome" style={{ display: "flex", alignItems: "center", gap: 16, padding: "0 16px", lineHeight: "64px" }}>
              {links.map(([to, id]) => (
                <NavLink key={to} to={to} style={{ color: "#fff" }} activeStyle={{ fontWeight: 700, textDecoration: "underline" }}>
                  {translations[locale][id]}
                </NavLink>
              ))}
              <span style={{ marginLeft: "auto", color: "#ddd", fontSize: 12 }}>{translations[locale].previewNotice}</span>
              <button type="button" onClick={() => setLocale(locale === "el" ? "en" : "el")} style={{ marginLeft: 12 }}>
                {locale === "el" ? "EN" : "ΕΛ"}
              </button>
            </Header>
            <Content style={{ padding: 16 }}>
              <Switch>
                <Route exact path="/preview/check-in" component={CheckIn} />
                <Route exact path="/preview/check-out" component={CheckOut} />
                <Route exact path="/preview/entries" component={Entries} />
                <Route exact path="/preview/report" component={Report} />
                <Route exact path="/preview/client" component={ClientCarpets} />
                <Redirect to="/preview/check-in" />
              </Switch>
            </Content>
          </Layout>
        </CarpetPreviewProvider>
      </ConfigProvider>
    </IntlProvider>
  );
}
